module.exports = __webpack_public_path__ + "img/deodorizersetHome_green.b3f8d4eb.svg";